import type { BackupListItem, BackupSettings, BackupSiteGroup, BackupsOverview, EnqueueResult, RestoreToHostRequest } from '@/types/api';
import { apiPage, apiRequest } from '@/api/client';

/** Every site's copies, their files, and putting one on an external server. */
export const backupsApi = {
  list: (cursor?: string | null) => apiPage<BackupListItem>(`/backups?limit=50${cursor ? `&cursor=${cursor}` : ''}`),

  /** Each server's share of the copies, the cap on copies per site, where they are kept (ADR-0056). */
  overview: () => apiRequest<BackupsOverview>('/backups/overview'),

  /** Sites with their copies slot by slot: on one server (`none` for none), by name or domain, only those with a problem. */
  sites: (filter: { serverId?: string | null; q?: string; problems?: boolean }) => {
    const query = new URLSearchParams();
    if (filter.serverId) query.set('serverId', filter.serverId);
    if (filter.q?.trim()) query.set('q', filter.q.trim());
    if (filter.problems) query.set('problems', 'true');
    return apiRequest<{ sites: BackupSiteGroup[]; total: number; limited: boolean }>(`/backups/sites?${query.toString()}`);
  },

  saveSettings: (settings: BackupSettings) => apiRequest<BackupSettings>('/backups/settings', { method: 'PUT', body: settings }),

  /** A part of a copy, downloaded by the browser with the session it already has. */
  downloadUrl: (backupId: string, name: string) => `/api/v1/backups/${backupId}/download/${encodeURIComponent(name)}`,

  restoreToHost: (backupId: string, input: RestoreToHostRequest, key: string) =>
    apiRequest<EnqueueResult>(`/backups/${backupId}/restore-to-host`, { method: 'POST', body: input, idempotencyKey: key }),
};
